import axios from 'axios';
import { message } from 'antd';
import {
  USERS_API
} from '../../../constants/API';
import {
  GET_ONBOARDING_CSV_LOADING,
} from '../types';

function getOnboardingCSV() {
  return async (dispatch, getState) => {
    dispatch({
      type: GET_ONBOARDING_CSV_LOADING,
      loadingOnboardingCSV: true
    });
    try {
      const accessToken = await localStorage.getItem('accessToken');
      const { userData } = getState().AuthReducer;
      await axios.get(
        `${USERS_API}/getOnboardingCSV/${userData.id}`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      dispatch({
        type: GET_ONBOARDING_CSV_LOADING,
        loadingOnboardingCSV: false,
      });
    } catch (e) {
      console.log(e);
      message.error(String(e));
      dispatch({
        type: GET_ONBOARDING_CSV_LOADING,
        loadingOnboardingCSV: false
      });
    }
  };
}
export default getOnboardingCSV;
